import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'

export default async function deleteCliente(ClienteId: number) {

  console.log('vai excluir o cliente: ',ClienteId)

  return await api.delete(URLS.CLIENTE_ID_API.replace('id', ClienteId.toString()))
  .then((response : any) => {
    Swal.fire({
      title: "Cliente Deletado",
      text: "O cliente foi apagado com sucesso!",
      icon: "success",
      position: "center",
      confirmButtonText: "OK",
      confirmButtonColor: "#349946",
      allowOutsideClick: false
    })
    return response;
  })
  .catch((err) => {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}